// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "paper-39tPN";
var _3 = "groupTitle-1Rc-p";
var _4 = "groupWrapper-1nty1";
var _5 = "active-3jr2F";
var _6 = "reasons-3l2lq";
var _7 = "reason-1Iewk";
export { _1 as "__esModule", _2 as "paper", _3 as "groupTitle", _4 as "groupWrapper", _5 as "active", _6 as "reasons", _7 as "reason" }
export default { "__esModule": _1, "paper": _2, "groupTitle": _3, "groupWrapper": _4, "active": _5, "reasons": _6, "reason": _7 }
